import React, {useEffect} from 'react';
import styles from './Modal.module.css';
import Modal from './Modal';
import ModalNotif from "./ModalNotif";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

function ModalSuccess({ children, onClose }) {
    return (
        <ModalNotif onClose={onClose} className={`${styles.modalSuccess} ${styles.modalContainer}`}>
            <FontAwesomeIcon icon={faCircleCheck}/>
            {children}
        </ModalNotif>
    );
}

export default ModalSuccess;
